const pwaState = {
    deferredInstallPrompt: null,
    registration: null,
    isRegistered: false,
    isRefreshing: false
};

export function setupPwa() {
    window.addEventListener('beforeinstallprompt', (event) => {
        event.preventDefault();
        pwaState.deferredInstallPrompt = event;
        window.dispatchEvent(new CustomEvent('ionds:pwa-state-change'));
    });

    window.addEventListener('appinstalled', () => {
        pwaState.deferredInstallPrompt = null;
        window.dispatchEvent(new CustomEvent('ionds:pwa-state-change'));
    });

    if (!('serviceWorker' in navigator) || process.env.NODE_ENV !== 'production') return;

    window.addEventListener('load', () => {
        navigator.serviceWorker.register(`${process.env.BASE_URL}service-worker.js`)
            .then((registration) => {
                pwaState.registration = registration;
                pwaState.isRegistered = true;
                window.dispatchEvent(new CustomEvent('ionds:pwa-state-change'));
            })
            .catch(() => {
                pwaState.registration = null;
                pwaState.isRegistered = false;
                window.dispatchEvent(new CustomEvent('ionds:pwa-state-change'));
            });
    });
}

export function getPwaState() {
    return {
        canInstall: !!pwaState.deferredInstallPrompt,
        isStandalone: isStandaloneMode(),
        isIos: isIosDevice(),
        isServiceWorkerSupported: 'serviceWorker' in navigator,
        isRegistered: pwaState.isRegistered,
        isControlled: !!navigator.serviceWorker?.controller
    };
}

export async function installPwa() {
    if (!pwaState.deferredInstallPrompt) return false;

    pwaState.deferredInstallPrompt.prompt();
    const result = await pwaState.deferredInstallPrompt.userChoice;
    pwaState.deferredInstallPrompt = null;
    window.dispatchEvent(new CustomEvent('ionds:pwa-state-change'));

    return result.outcome === 'accepted';
}

export async function updatePwa() {
    if (!('serviceWorker' in navigator)) return false;

    const registration = pwaState.registration || await navigator.serviceWorker.getRegistration();
    if (!registration) return false;

    await registration.update();

    if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }

    return true;
}

export async function getPwaStorageEstimate() {
    if (!navigator.storage?.estimate) return null;

    const estimate = await navigator.storage.estimate();
    return {
        quota: estimate.quota || 0,
        usage: estimate.usage || 0
    };
}

function isStandaloneMode() {
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
}

function isIosDevice() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}
